import { t } from 'i18next';
import { Button } from '../../../../components/buttons/Button';
import { useNavigate } from 'react-router';
import { Grid } from '@mui/material';

interface FreemiumButtonsProps {
  mobile: boolean;
}

const FreemiumButtons: React.FC<FreemiumButtonsProps> = ({ mobile }) => {
  const navigate = useNavigate();

  const navToManagePayments = () => navigate('/settings/manage-payments');

  return (
    <Grid display='flex' flexDirection='row' alignItems='center' mt={'40px'} mb={'35px'}>
      <Button
        sx={{
          width: mobile ? '100%' : 'auto',
        }}
        variant='outlined'
        color='primary'
        onClick={navToManagePayments}>
        {t('ManagePayments')}
      </Button>
    </Grid>
  );
};
export default FreemiumButtons;
